import Vue from 'vue'
import Vuex from 'vuex'

// import { menus } from './menu.module'
import { form } from './modules/form.module'
import { graduates } from './modules/graduates.module'
import { website } from './modules/website.module'
import { page } from './modules/page.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    page,
    // menus,
    form,
    graduates,
    website
  }
})
